import { MapType } from 'features/maps/types'
import { select } from 'redux-saga/effects'
import { getLayers } from './keplerGlSlice'
import { getDatasetsByType } from 'features/maps/state/mapsSlice'
import { KeplerLayer } from '../types'

export function* getDatasetLabel(source: string, type: MapType) {
  try {
    switch (type) {
      case MapType.raster:
      case MapType.table:
      case MapType.tileset:
        return source.substring(source.lastIndexOf('.') + 1).toLowerCase()
      case MapType.query:
        // eslint-disable-next-line no-case-declarations
        const datasets: unknown[] = yield select(getDatasetsByType, MapType.query)
        return `SQL Query ${datasets.length}`
    }
  } catch (error) {
    throw Error(`Cannot get dataset label. ${(error as Error).message}`)
  }
}

export function getNewLayerLabel(layers: KeplerLayer[]) {
  let labelNumber = layers.length + 1
  for (let i = 0; i < layers.length + 1; i++) {
    const newLabel = `Layer ${labelNumber}`
    if (!layers.find((layer) => layer.config.label === newLabel)) {
      return newLabel
    }
    labelNumber++
  }
  return 'New layer'
}

export function* getNextLayerLabel() {
  try {
    const layers: KeplerLayer[] = yield select(getLayers)
    return getNewLayerLabel(layers)
  } catch (e) {
    throw Error(`Cannot get datasets for storage ${e}`)
  }
}
